import { Modal } from "antd";
import { Capacitor } from "@capacitor/core";
import { svg } from "../Assets/svg";
import { openAppSettings } from "../helpers/nativePermissions";

type PermissionDeniedModalProps = {
  isModalOpen: boolean;
  handleClose: () => void;
  permissionName: string;
  onRetry?: () => void;
};

const PermissionDeniedModal = ({
  isModalOpen,
  handleClose,
  permissionName,
  onRetry,
}: PermissionDeniedModalProps) => {
  const isWeb = !Capacitor.isNativePlatform();

  const onOpenSettings = () => {
    if (isWeb) {
      // On web, re-trigger the browser's permission prompt
      if (onRetry) {
        onRetry();
      }
      handleClose();
      return;
    }
    openAppSettings();
    handleClose();
  };

  return (
    <Modal
      open={isModalOpen}
      footer={null}
      closeIcon={svg?.closeIcon}
      width={"30rem"}
      className="commonModalClass"
      centered
      zIndex={10050}
      onCancel={handleClose}
    >
      <div className="d-flex flex-column align-items-center justify-content-center gap-2 text-center">
        <div className="fw-bold fs-4">Permission Required</div>
        <div className="fw-normal fs-6">
          <strong>{permissionName}</strong> permission is disabled.{" "}
          {isWeb
            ? "Please allow camera access in your browser to use face scanning."
            : "You can enable it from your device settings."}
        </div>
        <div className="row justify-content-center mt-2">
          <div className="col-auto">
            <button
              className="btn btn-lg btn-outline-secondary px-3 text-nowrap"
              onClick={handleClose}
            >
              Cancel
            </button>
          </div>
          <div className="col-auto">
            <button
              className="btn btn-lg btn-primary px-3 text-nowrap"
              onClick={onOpenSettings}
            >
              {isWeb ? "Grant Access" : "Open Settings"}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default PermissionDeniedModal;
